<template>
 <div class="package-dialog">
	<el-dialog :title="title" :visible.sync="showDialog" :before-close="close" :close-on-click-modal="false">
			<pt-form-item label="中文名称" :labelWidth="labelWidth">
				<el-input v-model="catForm.name"></el-input>
			</pt-form-item>
			<pt-form-item label="英文名称" :labelWidth="labelWidth">
				<el-input v-model="catForm.englishName"></el-input>
			</pt-form-item>
			<pt-form-item label="是否为概述分类" :labelWidth="labelWidth">
				<el-radio v-model="catForm.summary" :label="true">是</el-radio>
				<el-radio v-model="catForm.summary" :label="false">否</el-radio>
			</pt-form-item>
		<div slot="footer" class="dialog-footer">
			<el-button @click="close">取 消</el-button>
			<!-- <el-button type="primary" @click="certain">确 定</el-button> -->
      <el-button type="primary" v-intervalclick="{func:certain,time:500}">确 定</el-button>
		</div>
	</el-dialog>
 </div>
</template>

<script>
export default {
  name: 'package-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      catForm: JSON.stringify(this.form) !== '{}' ? this.form : {},
      labelWidth: '120px'
    }
  },
  computed: {
    showDialog () {
      return this.dialogVisible
    }
  },
  watch: {
    form (val) {
      this.catForm = val
    }
  },
  methods: {
    close () {
      this.catForm = {}
      this.$emit('update', false)
    },
    certain () {
      this.catForm.type = 'CATEGORY'
      if (this.isEdit) {
        this.$emit('updateCategory', this.catForm)
      } else {
        this.$emit('addCategory', this.catForm)
      }
      this.close()
    }
  }
}
</script>

<style lang="less">
.package-dialog{
  .el-dialog{
    min-width: 600px;
  }
}
</style>
